import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Props as CumulativePrizePoolProps } from './CumulativePrizePool/index.tsx';
import { CumulativePrizePool } from './CumulativePrizePool/index.tsx';
import type { Props as DefaultPrizePoolProps } from './DefaultPrizePool/index.tsx';
import { DefaultPrizePool } from './DefaultPrizePool/index.tsx';
import type {
  PrizePoolWidget_so5Leaderboard,
  PrizePoolWidget_so5LeaderboardContender,
} from './__generated__/index.graphql.ts';

type Props = DefaultPrizePoolProps &
  CumulativePrizePoolProps & {
    so5Lineup?: { id: string };
  };

export const PrizePoolWidget = (props: Props) => {
  const { so5Leaderboard } = props;

  const isCumulative = so5Leaderboard.universalSo5UserGroups?.length;

  return isCumulative ? (
    <CumulativePrizePool {...props} />
  ) : (
    <DefaultPrizePool {...props} />
  );
};

PrizePoolWidget.fragments = {
  so5Leaderboard: gql`
    fragment PrizePoolWidget_so5Leaderboard on So5Leaderboard {
      slug
      universalSo5UserGroups {
        slug
      }
      ...DefaultPrizePool_so5Leaderboard
      ...CumulativePrizePool_so5Leaderboard
    }
    ${DefaultPrizePool.fragments.so5Leaderboard}
    ${CumulativePrizePool.fragments.so5Leaderboard}
  ` as TypedDocumentNode<PrizePoolWidget_so5Leaderboard>,
  so5LeaderboardContender: gql`
    fragment PrizePoolWidget_so5LeaderboardContender on So5LeaderboardContender {
      slug
      ...DefaultPrizePool_so5LeaderboardContender
      ...CumulativePrizePool_so5LeaderboardContender
    }
    ${DefaultPrizePool.fragments.so5LeaderboardContender}
    ${CumulativePrizePool.fragments.so5LeaderboardContender}
  ` as TypedDocumentNode<PrizePoolWidget_so5LeaderboardContender>,
};
